export default {
  title: 'Aiuto e FAQ',
  buttons: {
    faqs: 'FAQ',
    contact_us: 'Contattaci',
  },
};
